/** @jsx isolateComponent */

import { Button } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

type Props = {
  onClick: () => void;
  text?: string;
};

export const UpgradeButton = ({ onClick, text = 'Upgrade' }: Props) => (
  <Button hasShadow={true} onClick={onClick}>
    {text}
  </Button>
);
